const o=0,t=1,c=2;export{c as INTERPOLATION_CUBIC,t as INTERPOLATION_LINEAR,o as INTERPOLATION_STEP};
